/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable react/prefer-stateless-function */

import React, { Component } from 'react';

export default class MindEdge extends Component {
  render() {
    return (
      <div className="mindEdge">
        <header>
          <div className="incLogo">
            <a href="https://fastcompany.com">
              <img
                alt="Fast Company"
                src="//images.fastcompany.net/image/upload/v1538500532/fcweb/FC_Logo_2018_amgwhf.svg"
              />
            </a>
          </div>

          <nav>
            <div>
              <a href="https://catalog.mindedge.com/fastcompany/brands/4/courses">
                REGISTER NOW
              </a>
              <a href="https://fastcompany.mindedgeonline.com/login.php">
                LOGIN
              </a>
              <a href="https://catalog.mindedge.com/fastcompany">CATALOG</a>
            </div>
          </nav>

          <div className="mindEdgeLogo">
            <span className="mindEdgeText">POWERED BY</span>
            <img
              alt="MindEdge"
              src="//images.fastcompany.net/image/upload/v1589394443/fc/mindedge-logo_g8sghh.svg"
            />
          </div>
        </header>

        <section className="intro">
          <h3>EXCLUSIVE ONLINE COURSE</h3>
          <h1>
            “Future-Proof” <br className="design-br" /> Your Career
          </h1>
          <h2>
            Essential Skills, <br className="mb-only" /> Essential to Your
            Success.
          </h2>

          <div className="notice">
            <div className="line1">50% Off</div>
            <div className="line2">Limited time offer</div>
            <div className="line3">
              <a href="https://catalog.mindedge.com/fastcompany">Learn more</a>
            </div>
          </div>
        </section>

        <section className="contentRow why">
          <div className="content">
            <div className="hed">
              Your Business and <br className="tablet-br" /> Career can Only{' '}
              <br className="tablet-br" /> grow if{' '}
              <br className="tablet-br-special" />you do.
            </div>

            <div className="dek">
              That is why <i>Fast Company</i> has developed “Future-Proofing
              Your Career,” an online course suite of best practices that will
              help you master the concepts, mindsets, and skills to help you
              thrive in this ever-changing, ever-innovating world.
            </div>

            <div className="button">
              Learn more
              <a href="https://catalog.mindedge.com/fastcompany" />
            </div>
          </div>

          <div className="image">
            <picture>
              <source
                media="(max-width: 520px)"
                srcset="//images.fastcompany.net/image/upload/v1589483527/fc/Photo_2x_l4xixu.png"
              />
              <source
                media="(min-width: 521px)"
                srcset="//images.fastcompany.net/image/upload/v1589489963/fc/why-1_aculul.jpg"
              />
              <img
                alt=""
                src="//images.fastcompany.net/image/upload/v1589489963/fc/why-1_aculul.jpg"
              />
            </picture>
          </div>
        </section>

        <section className="quote">
          “<i>Fast Company</i> courses are<br className="desktop-only" />{' '}
          <i>more refined</i>, <i>more challenging</i>,{' '}
          <br className="desktop-only" />
          and <i>more effective</i> than your<br className="desktop-only-special" />{' '}
          typical online offerings.”
        </section>

        <section className="contentRow start">
          <div className="image">
            <picture>
              <source
                media="(max-width: 520px)"
                srcset="//images.fastcompany.net/image/upload/v1589490080/fc/Photo_2x_ndibvc.png"
              />
              <source
                media="(min-width: 521px)"
                srcset="//images.fastcompany.net/image/upload/v1589490031/fc/start-1_ha2djo.jpg"
              />
              <img
                alt=""
                src="//images.fastcompany.net/image/upload/v1589490031/fc/start-1_ha2djo.jpg"
              />
            </picture>
          </div>

          <div className="content">
            <div className="hed">
              Start Your{' '}
              <i>
                Fast <br className="tablet-br" />Company
              </i>{' '}
              Certificate <br className="tablet-br" /> Courses Now!
            </div>

            <div className="dek">
              <p>
                Fully interactive, progressing your own pace, and enhanced by
                hand-picked Fast Company content, “Future-Proof Your Career”
                courses are sure to boost—or reenergize—your business-running
                success.
              </p>

              <p>Don’t wait. Invest in your most important asset…you!</p>
            </div>

            <div className="button">
              Learn more
              <a href="https://catalog.mindedge.com/fastcompany" />
            </div>
          </div>
        </section>

        <section className="columns-row">
          <div className="header">
            Certificate Courses <br /> Include
          </div>

          <div className="arrow">
            <img
              alt=""
              src="//images.fastcompany.net/image/upload/v1589558752/fc/arrow_xdohxb.svg"
            />
          </div>

          <div className="columns">
            <div className="column">
              <div className="image">
                <img
                  src="//images.fastcompany.net/image/upload/v1589567535/fc/column1_c5gdca.png"
                  alt=""
                />
              </div>
              <div className="mobile">
                <div className="hed">
                  Design <br className="mobile-only" /> Thinking
                </div>
                <div className="dek">
                  Design thinking Strategies and methods for generating
                  innovative products and ideas that can set an organization
                  apart from its competitors.
                </div>
              </div>
            </div>

            <div className="divider" />

            <div className="column">
              <div className="image">
                <img
                  src="//images.fastcompany.net/image/upload/v1589567538/fc/column2_nzda36.png"
                  alt=""
                />
              </div>
              <div className="mobile">
                <div className="hed">
                  Communicating <br className="desktop-only" /> with flair
                </div>
                <div className="dek">
                  Beyond having clarity and purpose, masterful communication is
                  attention grabbing, engaging and memorable. Here you’ll find
                  tools to elevate your own.
                </div>
              </div>
            </div>

            <div className="divider" />

            <div className="column">
              <div className="image">
                <img
                  src="//images.fastcompany.net/image/upload/v1589567531/fc/column3_b3fgxm.png"
                  alt=""
                />
              </div>
              <div className="mobile">
                <div className="hed hed_special">personal branding </div>
                <div className="dek">
                  Stand out from the crowd by following simple, deliberate and
                  effective best practices – expanding your overall presence in
                  the process.
                </div>
              </div>
            </div>

            <div className="divider" />

            <div className="column">
              <div className="image">
                <img
                  src="//images.fastcompany.net/image/upload/v1589567537/fc/column4_codwn0.png"
                  alt=""
                />
              </div>
              <div className="mobile">
                <div className="hed">Networking </div>
                <div className="dek">
                  Make effective professional connections and cultivate
                  relationships that can help you over the course of your
                  career.
                </div>
              </div>
            </div>
          </div>
        </section>

        <footer>
          <div className="hed">
            GET THE TOOLS YOU NEED <br /> TODAY AND EVERYDAY!
          </div>
          <div className="arrow">
            <img
              alt="arrow"
              src="//images.fastcompany.net/image/upload/v1589558752/fc/arrow_xdohxb.svg"
            />
          </div>
          <div className="button">
            LEARN MORE
            <a href="https://catalog.mindedge.com/fastcompany" />
          </div>
        </footer>
      </div>
    );
  }
}
